import popupIcon from '../../common/Images/popup.png';

import styles from './IndicatorBox.module.css';

const IndicatorBox = ({ name, count, onClick }) => {
    return (
        <div
            className={styles.warper}
            onClick={() => {
                if (onClick) {
                    onClick();
                }
            }}>
            <div className={styles.upSide}>
                <div className={styles.count}>{count}</div>
                <div>
                    <img src={popupIcon} alt="" />
                </div>
            </div>
            <div className={styles.name}>{name}</div>
        </div>
    );
};

export default IndicatorBox;
